import { useId } from "react";

export default function LogoMark({ className, title = "NewFW" }) {
  const uid = useId().replace(/:/g, "");
  const gid = `${uid}-g`;

  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <defs>
        <linearGradient
          id={gid}
          x1="10"
          y1="2"
          x2="54"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9D5FF" />
          <stop offset=".4" stopColor="#8B5CF6" />
          <stop offset="1" stopColor="#5B21B6" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="32" fill={`url(#${gid})`} />
      <g
        stroke="#fff"
        strokeWidth="7.2"
        strokeLinecap="round"
        fill="none"
      >
        <path d="M23.5 17.5L17.5 46.5" />
        <path d="M46.5 17.5L40.5 46.5" />
        <path d="M23.5 17.5L40.5 46.5" />
      </g>
      <g fill="#fff">
        <circle cx="23.5" cy="17.5" r="6.2" />
      </g>
    </svg>
  );
}
